import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ecmappIm",
  "use": "icon-ecmappIm-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-ecmappIm\"><path d=\"M960 608a224 224 0 0 1-224 224H256a192 192 0 0 1-32-381.44V448a288 288 0 0 1 570.24-56A224 224 0 0 1 960 608zM262.08 448zM128 640a128 128 0 0 0 128 128h480a160 160 0 0 0 25.28-317.76 32 32 0 0 1-26.88-28.16A224 224 0 0 0 288 448a227.2 227.2 0 0 0 1.92 28.16 32 32 0 0 1-32 36.16H256A128 128 0 0 0 128 640z\" p-id=\"40707\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol